import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "./Staff.css";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import NewsLetterComponent from "../components/NewsLetterComponent";
import axios from "axios";
import Loader from "react-loader-spinner";
import { readTime } from "../functions/Functions";

export default class StaffDetails extends Component {
  state = {
    profile: {},
    newsletters: [],
    loading: true,
    error: false,
  };

  componentDidMount() {
    const { handle } = this.props.match.params;

    axios
      .get(`/v1/api/profile/${handle}`)
      .then((res) =>
        this.setState({
          profile: res.data,
          newsletters: res.data.newsletters || [],
          loading: false,
        })
      )
      .catch((err) => {
        console.error("Staff detail API failed:", err);
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { profile, newsletters, loading, error } = this.state;

    return (
      <div className="App">
        <Header />

        <Banner
          page={profile.full_name || "Staff Profile"}
          middlePage="Staff"
          middleLink="/staff"
          pageName="Staff Profile"
        />

        <section className="fsm-section fsm-staff-detail">
          <div className="container">
            {loading && (
              <div className="fsm-loader">
                <Loader
                  type="TailSpin"
                  color="#E32227"
                  height={70}
                  width={70}
                />
              </div>
            )}

            {error && !loading && (
              <div className="fsm-empty-state">
                <h3>Unable to load profile</h3>
                <p>Please check your connection and try again.</p>
                <Link to="/staff" className="fsm-btn fsm-btn-primary">
                  Back to Staff
                </Link>
              </div>
            )}

            {!loading && !error && profile.id && (
              <div className="fsm-staff-detail-grid">
                {/* LEFT: profile card */}
                <aside className="fsm-staff-detail-card">
                  <div className="fsm-staff-detail-img">
                    <img src={profile.image} alt={profile.full_name} />
                  </div>

                  <h1>{profile.full_name}</h1>
                  <span className="fsm-staff-position">
                    {profile.position}
                  </span>

                  {(profile.facebook_link ||
                    profile.twitter_link ||
                    profile.instagram_link) && (
                    <div className="fsm-staff-detail-socials">
                      {profile.facebook_link && (
                        <a
                          href={profile.facebook_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Facebook"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      )}
                      {profile.twitter_link && (
                        <a
                          href={profile.twitter_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Twitter"
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      )}
                      {profile.instagram_link && (
                        <a
                          href={profile.instagram_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Instagram"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      )}
                    </div>
                  )}

                  <Link to="/staff" className="fsm-staff-back">
                    ← Back to Staff
                  </Link>
                </aside>

                {/* RIGHT: bio + newsletters */}
                <div className="fsm-staff-detail-main">
                  <div className="fsm-staff-about">
                    <h2>About</h2>
                    <p>{profile.about}</p>
                  </div>

                  <div className="fsm-staff-newsletters">
                    <h2>Newsletters</h2>

                    {newsletters.length === 0 ? (
                      <div className="fsm-empty-state fsm-empty-small">
                        <p>No newsletters available for this staff member.</p>
                      </div>
                    ) : (
                      newsletters.map((newsletter, i) => (
                        <NewsLetterComponent
                          key={i}
                          title={newsletter.title}
                          date={readTime(newsletter.date_pulished)}
                          description={newsletter.short_description}
                          file={newsletter.file}
                        />
                      ))
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}